<template>
  <div class="wrap">
<!--    <div class="list_title list_title-top">-->
<!--      Campus Introduction-->
<!--    </div>-->

    <div class="page_wapper">
      <div class="text_constent wow slideInDown" id="campus">
        <img align='left' class="text_constent_img" src="http://en.sc.ruc.edu.cn/static/images/Introduction/png8.png"/>
        <div class="h1">About the Campus</div>
        <div class="text article-cont">
          <p>
            Renmin University of China (RUC) Suzhou Campus, officially established in September 2012, is located in SIP’s Dushu Lake Science & Education Innovation Zone (DLSEIZ), the first "Model District for Internationalization of Higher Education" in China. It is in the core area of China (Jiangsu) Pilot Free Trade Zone Suzhou Area.
          </p>

          <p>
            As a vital part of the overall development and a new growth point of RUC, Suzhou Campus acts as a key link in RUC’s “multi-district linkage” strategy. It is significant for the development of RUC in the new era, a new engine for internationalization enhancement of RUC, a strategic pivot for Yangtze River Delta to go integrated and cities of this area go global and a strategic platform for RUC to run a university for the world.
          </p>


        </div>
      </div>
    </div>


    <div class="majorsBox">
      <div class="majorsBox_wapper">


      <div class="majorsBox_title" id="majors">
        Majors
      </div>
      <div class="news_list">
        <div class="news_list_item  wow flipInX">
          <!--          <div class="img">-->
          <!--            <img src="static/assets/images/Introduction/l11.png"/>-->
          <!--          </div>-->
          <div class="content">
            <div class="tit">Sino-French Institute</div>
            <ul class="text">
              <li>Finance,</li>
              <li>National Economic & Management,</li>
              <li>French,</li>
              <li>Mathematics & Applied Mathematics,</li>
              <li>Human Resources Management,</li>
              <li>Finance,</li>
              <li>Communication Studies(International Journalism and Communication)</li>
            </ul>
          </div>
        </div>
        <div class="news_list_item wow flipInX">
          <!--          <div class="img">-->
          <!--            <img src="static/assets/images/Introduction/l12.png"/>-->
          <!--          </div>-->
          <div class="content">
            <div class="tit">School of Smart Governance</div>
            <ul class="text">
              <li>Master of Electronic & Information(Artificial Intelligence & Intelligent Governance),</li>
              <li>Master of Digital Economy(Digital Economy & Intelligent Governance),</li>
              <li>Master of Digital Economy(Humanistic Economy),</li>
              <li>Master of Finance(Financial Technology & Intelligent Governance),</li>
              <li>Doctor of Electronic & Information(Artificial Intelligence & Intelligent Governance)</li>
            </ul>
          </div>
        </div>
        <div class="news_list_item wow flipInX">
          <!--          <div class="img">-->
          <!--            <img src="static/assets/images/Introduction/l13.png"/>-->
          <!--          </div>-->
          <div class="content">
            <div class="tit">Silk Road School</div>
            <ul class="text">
              <li>The Master’s program of Contemporary China Studies (MCCS)</li>
            </ul>
          </div>
        </div>
        <div class="news_list_item wow flipInX">
          <!--          <div class="img">-->
          <!--            <img src="static/assets/images/Introduction/l14.png"/>-->
          <!--          </div>-->
          <div class="content">
            <div class="tit">International College<br/>(Suzhou Research Institute)</div>
            <ul class="text">
              <li>Master of Chinese International Education</li>
              <li>Master of Finance（Risk Management）</li>
              <li>Doctor of Finance（Risk Management）</li>
            </ul>
          </div>
        </div>
      </div>
      </div>
    </div>


    <div class="campus_wapper " id="Employment">
      <div class="list_title">Enrollment and Employment</div>
      <div class="campus wow bounceInRight" style="background: rgba(230, 206, 180, .8); color: #882B2D;">
        <h1>Basic Data</h1>
        <p>
          By far, there are 1,601 students in Suzhou Campus of RUC. This campus has a
          current enrollment of 1,551 full-time students, including 1,135 undergraduates
          of Sino-French Institute, 355 postgraduates of the International College,
          1 doctoral student of International College, and 60 international students
          of the Silk Road School. There are also 50 non-degree students, containing 10
          students of the Sino-European Programme of European Law and 83 short-term exchange students.
        </p>
        <div class="campus_wapper_tb">
            <div class="campus_wapper_tb_item">
              <div class="campus_wapper_tb_item_top">
                <div class="campus_wapper_tb_item_top_lf">
                  <div class="campus_wapper_tb_item_top_lf_tit">full-time students</div>
                  <div class="campus_wapper_tb_item_top_lf_nub">1551</div>
                </div>
                <div class="campus_wapper_tb_item_top_rt">
                  <div class="campus_wapper_tb_item_top_rt_li">
                    <div class="campus_wapper_tb_item_top_rt_li_t">Sino-French Institute</div>
                    <div class="campus_wapper_tb_item_top_rt_li_b">
                      <div class="campus_wapper_tb_item_top_rt_li_b_line">
                        <div class="campus_wapper_tb_item_top_rt_li_b_line_lf" style="width: 60%"></div>
                        <div class="campus_wapper_tb_item_top_rt_li_b_line_rt">1135</div>
                      </div>
                    </div>
                  </div>

                  <div class="campus_wapper_tb_item_top_rt_li">
                    <div class="campus_wapper_tb_item_top_rt_li_t">International College</div>
                    <div class="campus_wapper_tb_item_top_rt_li_b">
                      <div class="campus_wapper_tb_item_top_rt_li_b_line">
                        <div class="campus_wapper_tb_item_top_rt_li_b_line_lf" style="width: 30%"></div>
                        <div class="campus_wapper_tb_item_top_rt_li_b_line_rt">335</div>
                      </div>
                    </div>
                  </div>

                  <div class="campus_wapper_tb_item_top_rt_li">
                    <div class="campus_wapper_tb_item_top_rt_li_t">School of Smart Governance</div>
                    <div class="campus_wapper_tb_item_top_rt_li_b">
                      <div class="campus_wapper_tb_item_top_rt_li_b_line">
                        <div class="campus_wapper_tb_item_top_rt_li_b_line_lf" style="width: 2%"></div>
                        <div class="campus_wapper_tb_item_top_rt_li_b_line_rt">1</div>
                      </div>
                    </div>
                  </div>

                  <div class="campus_wapper_tb_item_top_rt_li">
                    <div class="campus_wapper_tb_item_top_rt_li_t">Silk Road School</div>
                    <div class="campus_wapper_tb_item_top_rt_li_b">
                      <div class="campus_wapper_tb_item_top_rt_li_b_line">
                        <div class="campus_wapper_tb_item_top_rt_li_b_line_lf" style="width: 20%"></div>
                        <div class="campus_wapper_tb_item_top_rt_li_b_line_rt">60</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="campus_wapper_tb_item_bot">
                <div class="campus_wapper_tb_item_bot_tip">
                  <div class="campus_wapper_tb_item_bot_tip_lf"></div>
                  <div class="campus_wapper_tb_item_bot_tip_rt">Graduate student</div>
                </div>
                <div class="campus_wapper_tb_item_bot_tip">
                  <div class="campus_wapper_tb_item_bot_tip_lf" style="background: #FFC029;"></div>
                  <div class="campus_wapper_tb_item_bot_tip_rt">Doctoral students</div>
                </div>
              </div>
            </div>

          <div class="campus_wapper_tb_item">
            <div class="campus_wapper_tb_item_top">
              <div class="campus_wapper_tb_item_top_lf">
                <div class="campus_wapper_tb_item_top_lf_tit">non-degree students</div>
                <div class="campus_wapper_tb_item_top_lf_nub">93</div>
              </div>
              <div class="campus_wapper_tb_item_top_rt">
                <div class="campus_wapper_tb_item_top_rt_li">
                  <div class="campus_wapper_tb_item_top_rt_li_t">Sino-European Programme</div>
                  <div class="campus_wapper_tb_item_top_rt_li_b">
                    <div class="campus_wapper_tb_item_top_rt_li_b_line">
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_lf" style="width: 11%"></div>
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_rt">10</div>
                    </div>
                  </div>
                </div>

                <div class="campus_wapper_tb_item_top_rt_li">
                  <div class="campus_wapper_tb_item_top_rt_li_t">hort-term exchange students</div>
                  <div class="campus_wapper_tb_item_top_rt_li_b">
                    <div class="campus_wapper_tb_item_top_rt_li_b_line">
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_lf" style="width: 89%"></div>
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_rt">83</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>

        <p>Since its establishment, the Suzhou Campus of RUC has trained 7,563 full-time students,
          among them 3,312 undergraduates, 4,154 postgraduate students and 97 doctoral students.
          It has also received 1,167 short-term exchange students from partner institutions,
          trained 448 students for the Sino-US Master's programme and 90 postgraduates for the Sino-European
          European Law programme.</p>
        <div class="campus_wapper_tb">
          <div class="campus_wapper_tb_item">
            <div class="campus_wapper_tb_item_top">
              <div class="campus_wapper_tb_item_top_lf">
                <div class="campus_wapper_tb_item_top_lf_tit">full-time students</div>
                <div class="campus_wapper_tb_item_top_lf_nub">7563</div>
              </div>
              <div class="campus_wapper_tb_item_top_rt">
                <div class="campus_wapper_tb_item_top_rt_li">
                  <div class="campus_wapper_tb_item_top_rt_li_t">undergraduates</div>
                  <div class="campus_wapper_tb_item_top_rt_li_b">
                    <div class="campus_wapper_tb_item_top_rt_li_b_line">
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_lf" style="width: 40%"></div>
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_rt">3312</div>
                    </div>
                  </div>
                </div>

                <div class="campus_wapper_tb_item_top_rt_li">
                  <div class="campus_wapper_tb_item_top_rt_li_t">postgraduate students</div>
                  <div class="campus_wapper_tb_item_top_rt_li_b">
                    <div class="campus_wapper_tb_item_top_rt_li_b_line">
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_lf" style="width: 50%"></div>
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_rt">4154</div>
                    </div>
                  </div>
                </div>

                <div class="campus_wapper_tb_item_top_rt_li">
                  <div class="campus_wapper_tb_item_top_rt_li_t">School of Smart Governance</div>
                  <div class="campus_wapper_tb_item_top_rt_li_b">
                    <div class="campus_wapper_tb_item_top_rt_li_b_line">
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_lf" style="width: 2%"></div>
                      <div class="campus_wapper_tb_item_top_rt_li_b_line_rt">97</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="campus_wapper_tb_round">
            <div class="campus_wapper_tb_item_round">
                <div class="campus_wapper_tb_item_round_nub">1167</div>
                <div class="campus_wapper_tb_item_round_name">
                  short-term<br/>
                  exchange students</div>
            </div>
            <div class="campus_wapper_tb_item_round">
              <div class="campus_wapper_tb_item_round_nub">448</div>
              <div class="campus_wapper_tb_item_round_name">
                students for the<br/>
                Sino-US Master's<br/>
                programme
              </div>
            </div>
            <div class="campus_wapper_tb_item_round">
              <div class="campus_wapper_tb_item_round_nub">90</div>
              <div class="campus_wapper_tb_item_round_name">
                postgraduates for the<br/>
                Sino-European European<br/>
                Law programme
              </div>
            </div>
          </div>

        </div>

      </div>

      <div class="campus wow bounceInLeft" style="background: rgba(180, 207, 230, .8); color: rgba(43, 67, 136, 1);">
        <h1 style="color: #2B4388">Enrollment</h1>
        <p>
          Nearly 60 students are enrolled annually in the Master's programme of Finance (Risk Management)
          in the International College. Candidates from first-rate universities account for over 85%,
          demonstrating an excellent quality of enrollment.
        </p>
        <p>
          The Sino-French Institute has an annual enrollment of 280 students from 2012 to 2022 and 310
          students in 2023. Since its establishment, the Silk Road School has enrolled 197 outstanding
          students from 62 countries along the "Belt and Road" and other countries, including Australia,
          Pakistan, Russia, France, Zimbabwe, the United States, the United Kingdom and so on. The past
          few years have also witnessed students from various countries coming to China to learn about its culture.</p>
        <p>
          The Enrollment of School of Smart Governance starts in 2024 with a planned admission of
          90 full-time graduate students and 10 part-time trained PhD students for the first session.
          The first term of study will start in September of 2024.
        </p>
        <div class="campus_wapper_tb">

          <div class="campus_wapper_tb_round">
            <div class="campus_wapper_tb_item_round">
              <div class="campus_wapper_tb_item_round_nub" style="border-color: #2B4388;color: #2B4388;">60</div>
              <div class="campus_wapper_tb_item_round_name" style="border-color: #2B4388;color: #2B4388;">
                International College
              </div>
            </div>
            <div class="campus_wapper_tb_item_round">
              <div class="campus_wapper_tb_item_round_nub" style="border-color: #2B4388;color: #2B4388;">280</div>
              <div class="campus_wapper_tb_item_round_name" style="border-color: #2B4388;color: #2B4388;">
                Sino-French Institute
              </div>
            </div>
            <div class="campus_wapper_tb_item_round">
              <div class="campus_wapper_tb_item_round_nub" style="border-color: #2B4388;color: #2B4388;">197</div>
              <div class="campus_wapper_tb_item_round_name" style="border-color: #2B4388;color: #2B4388;">
                Silk Road School
              </div>
            </div>
          </div>

          <div class="campus_wapper_tb_round">
            <div class="campus_wapper_tb_item_round">
              <div class="campus_wapper_tb_item_round_li">
                <div class="campus_wapper_tb_item_round_li_clip">
                  <div class="campus_wapper_tb_item_round_li_clip_box">
                  <div class="campus_wapper_tb_item_round_li_clip_nub" style="border-color: #2B4388;color: #2B4388;">90</div>
                  <div class="campus_wapper_tb_item_round_li_clip_tit" style="border-color: #2B4388;color: #2B4388;">
                    full-time<br/>
                    graduate<br/>
                    students
                  </div>
                  </div>
                </div>
                <div class="campus_wapper_tb_item_round_li_clip" style="margin-left: -20px;">
                  <div class="campus_wapper_tb_item_round_li_clip_box">
                    <div class="campus_wapper_tb_item_round_li_clip_nub" style="border-color: #6178B9;color: #6178B9;">10</div>
                    <div class="campus_wapper_tb_item_round_li_clip_tit" style="border-color: #6178B9;color: #6178B9;">
                      part-time trained<br/>
                      PhD students<br/>
                      for the first session
                    </div>
                  </div>

                </div>
              </div>

              <div class="campus_wapper_tb_item_round_name" style="color: #2B4388;">
                School of Smart Governance
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="campus wow bounceInRight article-cont" style="background: rgba(229, 178, 145, .8); color: rgba(136, 43, 45, 1);">
        <h1 style="color: #882B2D">Employment</h1>
        <p>
          The Suzhou Campus of RUC is committed to cultivating outstanding talents with international
          vision and profound professionalism. In 2023, part of graduates of the Sino-French Institute
          started their careers in governmental units and banks, etc., and 77 students pursued graduate
          study in partner institutions in France. In addition, 123 graduates, most of whom were admitted
          to the world's most prestigious universities, went abroad for further study. Among them 5 students
          were admitted to University of Cambridge and 8 were enrolled by London School of Economics and
          Political Science.
        </p>
        <p>
          Graduates of International College’s Master in Finance choose to work in important government
          agencies, first-class securities and fund institutions, large commercial banks and other top
          financial institutions, maintaining the job matching rate of 100 percent in 2023.
        </p>
          <p>
          Graduates of Silk Road School choose to pursue employment in government departments,
          the education sector, reputed companies and some of them choose to pursue doctoral studies
          for further education. Outstanding alumni of Silk Road School include Shahzad Ahmed,
          Deputy Director of Board of Investment (Overseas Investments) of Prime Minister’s Office,
          Pakistan; Shafiullah Farzayee, Advisor to the Minister of Interior, Afghanistan; Gabriela Ayon Chang,
          Advisor to the Food and Agriculture Organization of the United Nations.
        </p>
        <div>
          <div class="row">
            <div class="col-md-6">
              <div class="campus_wapper_tabClip">
                <div class="campus_wapper_tabClip_numb">77</div>
                <div class="campus_wapper_tabClip_content">
                  students pursued graduate study in partner<br/>
                  institutions in France
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="campus_wapper_tabClip">
                <div class="campus_wapper_tabClip_numb">123</div>
                <div class="campus_wapper_tabClip_content">
                  most of whom were admitted to the world's<br/>
                  most prestigious universities
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="campus_wapper_tabClip">
                <div class="campus_wapper_tabClip_numb">5</div>
                <div class="campus_wapper_tabClip_content">
                  admitted to University of Cambridge
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="campus_wapper_tabClip">
                <div class="campus_wapper_tabClip_numb">8</div>
                <div class="campus_wapper_tabClip_content">
                  enrolled by London School of Economics and<br/>
                  Political Science
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  watch: { // 监听，当路由发生变化的时候执行
    $route (to, from) {
      if (to) {
        const hash = this.$route.hash
        const position = document.getElementById(hash.substring(1))
        if (position) {
          this.$nextTick(() => {
            position.scrollIntoView()
          })
        }
      }
    }
  },
  mounted () {
    const hash = this.$route.hash
    if (hash) {
      const position = document.getElementById(hash.substring(1))
      if (position) {
        this.$nextTick(() => {
          position.scrollIntoView()
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top_img {
  background: #F6F4EF;
  width: 100%;

  img {
    width: 100%;
    display: block;
  }
}

.wrap {
  background-color: #F6F4EF;
  overflow: auto;
  background-position: left 5%;
  background-size: 80%;
  background-repeat: no-repeat;
  background-image: url(http://en.sc.ruc.edu.cn/static/images/Introduction/1.png);
}

.page_wapper {
  width: 1180px;
  margin: 0 auto;
  padding-top: 240px;
}

.text_constent {
  padding: 50px;
  background: #CFB59C;
  color: #fff;
  font-family: 'Cambria Math';
  box-shadow: 0px 8px 21px 1px rgba(72, 58, 58, 0.54);
  margin-bottom: 100px;
  .h1 {
    font-family: 'Cambria Mat'h;
    font-weight: 400;
    font-size: 62px !important;
    color: #483816 !important;
    position: relative;
    padding-top: 100px;
    z-index: 1;
    //line-height: 20px;
  }
  .h1:before {
    content: "";
    display: block;
    width: 200px;
    height: 90px;
    position: absolute;
    top: 30px;
    left: calc(45% + 50px);
    background-image: url(http://en.sc.ruc.edu.cn/static/images/Introduction/png1.png);
    background-repeat: no-repeat;
    background-size: 100%;
    z-index: 0;
  }
  p {
    //margin-bottom: 20px;
    font-family: 'Cambria Math';
    font-weight: 400;
    font-size: 20px;
    color: #090909;
    line-height: 1.6;
  }
}
.text_constent_img{
  width: 45%;
  margin: 30px 35px 20px 0;
  //shape-outside: circle(50%);
}

.h1 {
  font-size: 32px;
  line-height: 60px;
}

.majorsBox{
  width: 100%;
  background-color: rgba(129, 9, 0, 1);
  padding: 30px 0 40px 0;
  background-image: url(http://en.sc.ruc.edu.cn/static/images/Introduction/png2.png);
  background-repeat: no-repeat;
  background-size: 30%;
}

.majorsBox_wapper{
  width: 1180px;
  margin: 0 auto;
}
.majorsBox_title{
  font-size: 50px;
  text-align: center;
  color: #fff;
  margin: 0 auto;
  width: fit-content;
  line-height: 150px;
  position: relative;
  z-index: 1;
}
.majorsBox_title:before{
  content: " ";
  display: block;
  width: 166px;
  height: 75px;
  position: absolute;
  left: 50%;
  top: 16px;
  margin-left: -83px;
  z-index: -1;
  background-image: url(http://en.sc.ruc.edu.cn/static/images/Introduction/png3.png);
  background-repeat: no-repeat;
  background-size: 100%;
}
.list_title {
  font-size: 50px;
  text-align: center;
  color: #872A2D;
  font-family: Cambria Math;
  line-height: 150px;

}
.list_title-top{
  padding-top: 200px;
}

.news_list {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 40px;
  justify-content: center;
  font-family: 'Cambria Math';

  &_item {
    background: rgba(207, 181, 156, 1);
    //box-shadow: 0px 8px 10px 0px rgba(71, 31, 21, 0.3);
    width: 520px;
    color: #872A2D;
    margin: 0 30px 20px;

    .img {
      img {
        width: 100%;
        height: 100%;
      }
    }

    .content {
      position: relative;
      text-align: center;
      //margin: 20px 20px 20px 20px;
      //background: rgba(207, 181, 156, 1);
      //padding: 20px;
      padding-top: 4px;
      height: 250px;

      .tit {
        width: 100%;
        height: 60px;
        background: linear-gradient(90deg, #E7D9BF 0%, rgba(229,210,191,0) 100%);
        font-weight: bold;
        font-size: 20px;
        color: #872A2D;
        display: flex;
        line-height: 24px;
        align-items: center;
        padding-left: 30px;
        margin-left: -10px;
      }

      .text {
        padding: 15px 25px 15px 40px;
        font-size: 14px;
        text-align: justify;
          li{
            list-style-type: disc;
          }
      }
    }
  }
}

.cricle {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 40px 0;

  &_item {
    width: 180px;
    height: 180px;
    border-radius: 100px;
    border: 2px solid #fff;
    color: #fff;
    padding: 20px;

    .icon img {
      width: 40px;
      height: 40px;
    }

    .text {
      line-height: 30px;
    }

    .num {
      font-size: 40px;
    }
  }
}


.campus_wapper {
  //background-position: center;
  background-size: 80%;
  background-repeat: no-repeat;
  background-image: url(http://en.sc.ruc.edu.cn/static/images/Introduction/400055550.png);
  padding-bottom: 20px;
  padding-top: 150px;
  background-position: top;
  position: relative;
  .list_title {
    font-size: 50px;
    text-align: center;
    color: #872A2D;
    line-height: 150px;
    position: absolute;
    width: 100%;
    top: 0px;
  }
}

.campus {
  font-family:' Cambria Math';
  padding: 30px;
  width: 1080px;
  margin: 0 auto 30px auto;
  box-shadow: 0px 8px 10px 0px rgba(71, 31, 21, 0.3);
  h1{

    font-weight: 400;
    font-size: 27px;
    color: #882B2D;
    line-height: 48px;
    text-align: center;
  }
  p {

    font-weight: 400;
    font-size: 16px;
    //color: #882B2D;
    line-height: 28px;
  }
}


.campus_wapper_tb{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 20px 0;
  .campus_wapper_tb_item{
    .campus_wapper_tb_item_top{
      display: flex;
      align-items: center;
        .campus_wapper_tb_item_top_lf{
          height: fit-content;
          position: relative;
          padding-right: 30px;
            .campus_wapper_tb_item_top_lf_tit{

              font-weight: 400;
              font-size: 14px;
              color: #565BB6;
              margin-bottom: 2px;
            }
          .campus_wapper_tb_item_top_lf_nub{

            font-weight: 400;
            font-size: 24px;
            color: #565BB6;
            text-align: right;
          }
        }
      .campus_wapper_tb_item_top_lf:after{
        position: absolute;
        right: 10px;
        top: 20px;
        content: ' ';
        width: 0;
        height: 0;
        border-top: 6px solid transparent;
        border-right: 6px solid transparent;
        border-left: 6px solid #565BB6;
        border-bottom: 6px solid transparent;
      }
      .campus_wapper_tb_item_top_rt{
        padding-left: 10px;
        border-left: 5px solid #565BB6;
        .campus_wapper_tb_item_top_rt_li{
          margin-bottom: 10px;
          .campus_wapper_tb_item_top_rt_li_t{

            font-weight: 400;
            font-size: 14px;
            color: #585DBF;
            line-height: 20px;
          }
          .campus_wapper_tb_item_top_rt_li_b{
            .campus_wapper_tb_item_top_rt_li_b_line{
              width: 210px;
              height: 30px;
              background: #FFFFFF;
              border-top-right-radius: 6px;
              border-bottom-right-radius: 6px;
              display: flex;
              align-items: center;
                .campus_wapper_tb_item_top_rt_li_b_line_lf{
                  //width: 150px;
                  height: 100%;
                  background: #565BB6;
                  border-top-right-radius: 6px;
                  border-bottom-right-radius: 6px;
                }
              .campus_wapper_tb_item_top_rt_li_b_line_rt{

                font-weight: 400;
                font-size: 12px;
                color: #565BB6;
                margin-left: 2px;
              }
            }
          }
        }
      }
    }
    .campus_wapper_tb_item_bot{
      display: flex;
      align-items: center;
      flex-direction: row-reverse;
      margin-top: 20px;
      .campus_wapper_tb_item_bot_tip{
        display: flex;
        align-items: center;
        margin-right: 20px;

          .campus_wapper_tb_item_bot_tip_lf{
            width: 16px;
            height: 9px;
            background: #565BB6;
            border-radius: 5px;
          }
        .campus_wapper_tb_item_bot_tip_rt{
          margin-left: 10px;

          font-weight: 400;
          font-size: 12px;
          color: #565BB6;
        }
      }
    }

  }
  .campus_wapper_tb_round{
    display: flex;
  }
  .campus_wapper_tb_item_round{
      margin-left: 40px;
    .campus_wapper_tb_item_round_li{
      display: flex;
      align-items: center;
      .campus_wapper_tb_item_round_li_clip{
        width: 120px;
        height: 120px;

        font-weight: bold;
        font-size: 24px;
        background: rgba(205,110,110,0);
        border-radius: 50%;
        border: 3px solid #6178B9;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        .campus_wapper_tb_item_round_li_clip_box{
          width: fit-content;
          height: fit-content;
          .campus_wapper_tb_item_round_li_clip_nub{
            font-weight: bold;
            font-size: 26px;
            color: #6178B9;
            margin: 0 auto;
            text-align: center;
          }
          .campus_wapper_tb_item_round_li_clip_tit{
            font-weight: 400;
            font-size: 10px;
            line-height: 12px;
            color: #6178B9;
            text-align: center;
          }
        }

      }
    }
    .campus_wapper_tb_item_round_nub{
      width: 86px;
      height: 86px;
      font-weight: bold;
      font-size: 24px;
      color: #B66156;
      background: rgba(205,110,110,0);
      border-radius: 50%;
      border: 3px solid #BE4444;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .campus_wapper_tb_item_round_name{
      font-weight: 400;
      font-size: 12px;
      color: #B66156;
      margin-top: 5px;
      text-align: center;
      line-height: 18px;
    }
  }
}

.campus_wapper_tabClip{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
    .campus_wapper_tabClip_numb{
      font-weight: bold;
      font-size: 32px;
      color: #CF5A34;
      width: 100px;
      height: 100px;
      padding: 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #EFD6B2;
      border: 3px solid #CC4E27;
      z-index: 2;
    }
  .campus_wapper_tabClip_content{
    font-weight: 400;
    font-size: 14px;
    color: #CF5A34;
    line-height: 16px;
    padding: 14px 60px;
    margin-left: -40px;
    background: rgba(255,255,255,0.57);
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
    z-index: 1;
  }
}

//.text_constent p{
//  text-align: justify !important;
//}


@media (max-width: 575.98px) {
  .majorsBox_wapper{
    width: 100%;
  }
  .page_wapper{
    padding-top: 40px;
  }
  .text_constent_img{
    width: 100%;
    margin-right: 0;
  }
  .text_constent .h1{
    font-size: 36px !important;;
  }
  .h1:before {
    display: none !important;
  }
  .text_constent p{

    line-height: 18px !important;
    font-size: 16px !important;
  }
  .list_title{
    font-size: 32px !important;
    line-height: 70px !important;
  }
  .list_title-top{
    padding-top: 10px !important;
    line-height: 40px !important;
    font-size: 32px !important;
  }
  .page_wapper {
    width: 100%;
  }
  .news_list_item {
    width: 100%;
      .content {
        height: auto !important;
      }
  }
  .cricle {
    padding: 30px;
    justify-content: center !important;
  }
  .cricle_item {
    margin-bottom: 20px;
  }
  .campus {
    width: 94%;
  }

  .campus_wapper_tabClip{
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .campus_wapper_tabClip_numb{
      flex-shrink: 0;
      font-family: HYZongYiJ;
      font-weight: bold;
      font-size: 16px;
      color: #CF5A34;
      width: 60px;
      height: 60px;
      padding: 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #EFD6B2;
      border: 2px solid #CC4E27;
      z-index: 2;
    }
    .campus_wapper_tabClip_content{
      font-family: Myriad Pro;
      font-weight: 400;
      font-size: 10px;
      color: #CF5A34;
      line-height: 14px;
      padding: 3px 30px;
      margin-left: -15px;
      background: rgba(255,255,255,0.57);
      border-top-right-radius: 15px;
      border-bottom-right-radius: 15px;
      z-index: 1;
    }
  }

  .campus_wapper_tb{
    display: block !important;
    .campus_wapper_tb_round{
    //display: flex;
      display: block !important;
  }
  .campus_wapper_tb_item_round{
    margin-left: 0px;
    margin-bottom: 20px;

    .campus_wapper_tb_item_round_li{
      display: flex;
      align-items: center;
      .campus_wapper_tb_item_round_li_clip{
        width: 120px;
        height: 120px;
        font-family: HYZongYiJ;
        font-weight: bold;
        font-size: 24px;
        background: rgba(205,110,110,0);
        border-radius: 50%;
        border: 3px solid #6178B9;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        .campus_wapper_tb_item_round_li_clip_box{
          width: fit-content;
          height: fit-content;
          .campus_wapper_tb_item_round_li_clip_nub{
            font-family: HYZongYiJ;
            font-weight: bold;
            font-size: 26px;
            color: #6178B9;
            margin: 0 auto;
            text-align: center;
          }
          .campus_wapper_tb_item_round_li_clip_tit{
            font-family: Myriad Pro;
            font-weight: 400;
            font-size: 10px;
            line-height: 12px;
            color: #6178B9;
            text-align: center;
          }
        }

      }
    }
    .campus_wapper_tb_item_round_nub{
      width: 140px;
      height: 140px;
      font-family: HYZongYiJ;
      font-weight: bold;
      font-size: 40px;
      color: #B66156;
      background: rgba(205,110,110,0);
      border-radius: 50%;
      border: 3px solid #BE4444;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
    }
    .campus_wapper_tb_item_round_name{
      font-family: Myriad Pro;
      font-weight: 400;
      font-size: 18px;
      color: #B66156;
      margin-top: 5px;
      text-align: center;
      line-height: 24px;
    }
  }
}
  .campus_wapper_tb .campus_wapper_tb_item .campus_wapper_tb_item_top{
    margin-bottom: 20px;
  }
  .campus_wapper_tb_item_top_rt_li_b_line{
    width: 130px !important;
  }
}
</style>



// WEBPACK FOOTER //
// Introduction.vue?769ba5f8